
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#798F8F","clip-path":"url(#clip0_6047_10)"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M13.502 8.865V5.497a1.33 1.33 0 0 0-.667-1.153L8.169 1.677a1.33 1.33 0 0 0-1.334 0L2.17 4.344a1.33 1.33 0 0 0-.667 1.153v5.333a1.33 1.33 0 0 0 .667 1.153l4.666 2.667a1.33 1.33 0 0 0 1.334 0"}}),_c('path',{attrs:{"stroke-linecap":"round","d":"M9.634 10.298a3.552 3.552 0 0 0-5.58 2.772m5.58-5.57a2.157 2.157 0 1 1-4.314 0 2.157 2.157 0 0 1 4.314 0Z"}}),_c('path',{attrs:{"d":"M13.706 10.5a1.09 1.09 0 1 1-.001 2.178 1.09 1.09 0 0 1 0-2.178Z"}}),_c('path',{attrs:{"stroke-linecap":"round","d":"m12.649 12.819-2.518 2.518M11.406 15.544l-.623-.623M12.369 14.481l-.623-.624M4.077 12.812a3.55 3.55 0 0 1 6.579-1.423"}})]),_c('defs',[_c('clipPath',{staticClass:"i-clip0_6047_10"},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h17v17H0z"}})])])])
          )
        }
      }
    